<template>
  <div>
    <div class="mr-2">
      <a class="nav-link ml-1">
        <i class="fa-fw fas fa-filter" /> <span class="ml-1 font-weight-bold">Filter</span>
      </a>
      <ul class="nav nav-pills">
        <li class="nav-item ml-2 list-item-none">
          <div class="nav-link">
            Fiscal Year
            <b-form-select v-model="fiscalYear">
              <b-form-select-option v-for="year in loadedYears" :key="year" :value="year">
                {{ year + 1990+1 }}
              </b-form-select-option>
            </b-form-select>
          </div>
        </li>
      </ul>
    </div>
    <ul class="nav nav-pills d-block mb-3">
      <li class="nav-item">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive' }">
          <object type="image/svg+xml" data="/Content/icons/LI-Districts.svg" class="svg-icon" /> Overall
        </router-link>
      </li>
      <!-- <li class="nav-item">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive/OutstandingGrowth' }">
          <i class="fas fa-chart-line mr-1" /> Outstanding Growth
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive/ShortageArea' }">
          <i class="fas fa-exclamation-triangle mr-1" /> Shortage Area
        </router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive/Mentoring' }">
          <i class="fas fa-user-friends mr-1" /> Mentoring
        </router-link>
      </li> -->
      <li class="nav-item" v-if="userContext && userContext.isInsightsAdmin">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive/CertifiedDistricts' }">
          <i class="fas fa-check-double mr-1" /> Districts Certified
        </router-link>
      </li>
      <li class="nav-item" v-if="userContext && userContext.isInsightsAdmin">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive/UncertifiedDistricts' }">
          <i class="fas fa-tasks mr-1" /> Districts Progress
        </router-link>
      </li>
      <!-- <li class="nav-item" v-if="userContext && userContext.isInsightsAdmin">
        <router-link class="nav-link" :to="{ path: '/HCPT/MeritIncentive/Configuration' }">
          <i class="fas fa-cog mr-1" /> Configuration
        </router-link>
      </li> -->
    </ul>
    <!-- <ul class="nav nav-pills flex-column ml-2 mr-2">
      <li class="nav-item ml-2">
        <router-link class="nav-link" active-class="active" :to="{path: `/HCPT/MeritIncentive`}">
          <img src="/Content/icons/incentive.png" class="svg-icon"> Merit Incentive Fund Data and Trends
        </router-link>
      </li>
    </ul>  -->
    <!-- 
    <ul class="nav nav-pills flex-column mt-1 mb-3">
      <li class="mr-2">
        <a class="nav-link ml-1">
          <span class="font-weight-bold">Resources</span>
        </a>
        <ul class="nav nav-pills dsubject-block">
          <li class="nav-item ml-2">
            <a href="/content/meritIncentive/Merit Incentive Fund Data and Trends Presentation.mp4" active-class="active" class="nav-link">
              <i class="fas fa-fw fa-video mr-1" /> Video Presentation
            </a>
          </li>
        </ul>
        <ul class="nav nav-pills dsubject-block">
          <li class="nav-item ml-2">
            <a href="/content/meritIncentive/Merit Incentive Fund Data and Trends Presentation.pptx" active-class="active" class="nav-link">
              <i class="fas fa-fw fa-file-powerpoint mr-1" /> PowerPoint Presentation
            </a>
          </li>
        </ul> 
        <ul class="nav nav-pills dsubject-block">
          <li class="nav-item ml-2">
            <a href="/content/meritIncentive/Merit Incentive Fund Data and Trends Presentation FINAL.pdf" active-class="active" class="nav-link">
              <i class="fas fa-fw fa-file-pdf mr-1" /> PDF Presentation
            </a>
          </li>
        </ul>
      </li>
    </ul> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      lea: null,
    }
  },
  computed: {
    ...mapState('tgsModule', ['loadedYears']),
    ...mapState('globalModule', ['userContext']),
    fiscalYear: {
      set(year) {
        this.$store.commit('tgsModule/setFiscalYear', year)
      },
      get() {
        return this.$store.state.tgsModule.fiscalYear
      }
    },
  },
  async created() {    
    if (this.$route.query.fy) {
      this.$store.commit('tgsModule/setFiscalYear', this.$route.query.fy)
      console.log('fy from query string', this.$route.query.fy)
    }
    else {
      await this.$store.dispatch('tgsModule/getFiscalYears')
      this.fiscalYear = this.loadedYears[0]
    }
  },
  methods: {
    async reloadData() {
      if (this.lea && this.fiscalYear)
      {
        // await this.$store.dispatch('tgsModule/getMeritTrends', {fiscalYear: this.fiscalYear, lea: this.lea})
        // await this.$store.dispatch('tgsModule/getStateSummary', {fiscalYear: this.fiscalYear})
        // await this.$store.dispatch('tgsModule/getDistrictSummary', {fiscalYear: this.fiscalYear})
        // await this.$store.dispatch('tgsModule/getMeritFundData', {lea: this.lea, fiscalYear: this.fiscalYear})
      }
    }
  },
  watch: {
    selectedLea: {
      immediate: true,
      handler(newData) {
        if (this.lea != newData.number)
        {
          this.lea = newData.number
          this.reloadData()
        }
      }
    },
    fiscalYear: {
      handler() {
        this.reloadData()
      }
    },
    category: {
      handler() {
        this.reloadData()
      }
    }
  },
}
</script>
